import { FadeLoader } from "react-spinners"

export default function Spinner() {
  return <FadeLoader color={"white"} />
}
